import React from 'react';
import { Link } from 'react-router-dom';
import { LayoutDashboard, ShoppingBag, History, User, Settings } from 'lucide-react';

const AdminLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen">
      <div className="w-64 bg-maroon text-white flex flex-col">
        <div className="p-6 text-xl font-bold border-b border-white/20">Admin Portal</div>
        <nav className="flex-1 p-4 space-y-2">
          <Link to="/admin" className="flex items-center p-3 hover:bg-white/10"><LayoutDashboard className="mr-3"/> Dashboard</Link>
          <Link to="/admin/stock" className="flex items-center p-3 hover:bg-white/10"><ShoppingBag className="mr-3"/> Stock Management</Link>
          <Link to="/admin/recycle" className="flex items-center p-3 hover:bg-white/10"><History className="mr-3"/> Recycle Bin</Link>
          <Link to="/admin/orders" className="flex items-center p-3 hover:bg-white/10"><User className="mr-3"/> Orders</Link>
          <Link to="/admin/settings" className="flex items-center p-3 hover:bg-white/10"><Settings className="mr-3"/> Settings</Link>
        </nav>
      </div>
      <div className="flex-1 bg-gray-50 p-10">{children}</div>
    </div>
  );
};

export default AdminLayout;